import type { PropsWithChildren } from 'react';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useSettings } from '@wu/widget-core';
import { getBackgroundStyle, getTextColor, WHITE } from '../../helpers';

interface ThemeContext {
  textColor: string;
  backgroundStyle: string;
}
const ThemeContext = createContext<ThemeContext>({
  textColor: WHITE,
  backgroundStyle: ''
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [color, setColor] = useState(WHITE);
  const [backgroundStyle, setBackgroundStyle] = useState('');

  const {
    textColor,
    colorScheme,
    backgroundType,
    backgroundColor,
    backgroundImage,
    backgroundImageOverlayColor
  } = useSettings();

  useEffect(() => {
    setColor(getTextColor(textColor, colorScheme));
    setBackgroundStyle(
      getBackgroundStyle(
        colorScheme,
        backgroundType,
        backgroundColor,
        backgroundImage,
        backgroundImageOverlayColor
      )
    );
  }, [
    textColor,
    colorScheme,
    backgroundType,
    backgroundColor,
    backgroundImage,
    backgroundImageOverlayColor
  ]);

  const value = useMemo(
    () => ({
      textColor: color,
      backgroundStyle
    }),
    [backgroundStyle, color]
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};
